module.exports = __webpack_public_path__ + "img/img9.60f226b5.png";